export enum SSX_HOUSE_CONTENT_OPTIONS {
  AKA = 'aka-innbo',
  HUSEIERNE = 'huseierne-innbo',
  STANDARD = 'innbo',
}

export enum SSX_GRP_OPTION {
  AFAG = 'afag',
  LEGEFORENINGEN = 'legeforeningen',
  TANNLEGEFORENINGEN = 'tannlegeforeningen',
  VETERINARENE = 'veterinarene',
  ECONA = 'econa',
  NATURVITERNE = 'naturviterne',
  LEKTORLAGET = 'lektorlaget',
  PSYKOLOGFORENINGEN = 'psykologforeningen',
  SAMFUNNSVITERNE = 'samfunnsviterne',
  SAMFUNNSOKONOMENE = 'samfunnsokonomene',
  COOP = 'coop',
  DANSKE_BANK = 'danskebank',
  HUSEIERNE = 'huseierne',
}
